import React, {useState} from 'react';
import { Flex } from "antd";
import {BackButton} from "../../../../shared";
import {StyledCard} from "./Header.styled";
import {useLocation, useNavigate} from "react-router-dom";
import {HeaderProps} from "../../models";
import { CloseOutlined } from '@ant-design/icons';

const Header = ({step} :HeaderProps) => {
    const [open, setOpen] = useState<boolean>(false)
    const navigate = useNavigate();
    const [activeTitle, setActiveTitle] = useState<string>('')
    const onCansel = () => {
        setOpen(false)
    }
    return (
        <StyledCard>
            <Flex vertical gap={"middle"}>
                <Flex justify={"space-between"} align={"center"} gap={"middle"}>
                    <Flex gap={"small"} align={"center"}>
                        {step > 1 && <CloseOutlined onClick={() => navigate('/')}/>}
                        <span>درج آگهی</span>

                    </Flex>
                    <img width={20} src={require("assets/Logo/logoPink.png")}/>

                </Flex>
            </Flex>
        </StyledCard>
    )

};

export default Header;
